var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"STree"},[_c('vue-easy-tree',{ref:"tree",staticStyle:{"width":"400px"},attrs:{"show-checkbox":"","node-key":"id","height":"300px","data":_vm.data,"default-expand-all":"","props":_vm.defaultProps,"highlight-current":"","empty-text":"","filter-node-method":_vm.filterNode},on:{"check-change":_vm.handleCheckChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394596a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodStree/index.vue
// module id = null
// module chunks = 